import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  .modal-shadow {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
  }
  .modal-content {
    background-color: var(--modal-background-color);
    min-width: 150px;
    min-height: 100px;
    width: unset;
    padding: 32px 20px;
    border-radius: 20px;
    position: relative;
    box-shadow: 0 0 50px #000000;

    .modal-close {
      position: absolute;
      top: 29px;
      right: 20px;
      font-size: 18px;
      background-color: transparent;
      padding: 10px;
      border-radius: 50%;
      border: none;
      color: #c7cad9;
      cursor: pointer;
      transition: all 0.5s;
      color: var(--primaryColor);
      &:hover {
        top: 27px;
      }
    }
  }
`;
